<template>
  <div id="manuscript-versions-dialog">
    <ipub-model :title="'Revision History'"
                width="900px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <ipub-table :columns="columns"
                  border
                  :dataSource="dataSource">
        <template v-slot:link="{text, record}">
          <a @click="download(`${domain}/${record.path}`, text)"
             class="link-color">{{text}}</a>
        </template>
      </ipub-table>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mfile from '@/api/mfile'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'File Name',
    width: 200,
    dataIndex: 'name',
    slot: 'link'
  },
  {
    title: '',
    enTitle: 'Date',
    width: 200,
    dataIndex: 'uploadTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 150,
    dataIndex: 'operator',
    slot: 'name'
  }
]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      columns,
      dataSource: [],
      download: help.download
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.dataSource = []
      } else {
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      this.dataSource = await mfile.history({
        manuscriptId: this.inputData.id,
        sign: this.inputData.sign
      })
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
